import { render, staticRenderFns } from "./NokToForeign.vue?vue&type=template&id=a10babea&"
import script from "./NokToForeign.vue?vue&type=script&lang=js&"
export * from "./NokToForeign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports